import { connect } from "react-redux";
import appPath from "utils/appPath";
import manageBulkSubscription from "ducks/manageBulkSubscription";
import BulkSubscriptionDetails from "components/v3/subscription-details/bulk-subscription-details/BulkSubscriptionDetails";
import { SCREENS } from "common/constants/Constants";
import { isBulkAdmin } from "utils/bulkSubscriptionUtils";

export function createMapStateToProps() {
    return (state, ownProps) => {
        const {
            manageBulkSubscription: {
                admins: adminMap
            },
            user = {}
        } = state;

        const {
            bulkSubscriptionMetadata: {
                id
            }
        } = ownProps;

        const admins = adminMap[id] || [];

        return {
            ...ownProps,
            isAdmin: isBulkAdmin(user.id, admins),
            admins,
            adminPanelUrl: `${ appPath.withoutQuery(SCREENS.MANAGE_SUBSCRIPTION) }?id=${ encodeURIComponent(ownProps.id) }`
        };
    };
}

export function mapDispatchToProps(dispatch, ownProps) {
    return {
        getAdmins() {
            dispatch(manageBulkSubscription.getAdmins(ownProps.bulkSubscriptionMetadata.id));
        }
    };
}

const BulkSubscriptionDetailsContainer = connect(
    createMapStateToProps(),
    mapDispatchToProps
)(BulkSubscriptionDetails);

export default BulkSubscriptionDetailsContainer;
